"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Axios_1 = require("client/Axios");
const locale_key_enum_1 = require("enums/locale-key.enum");
const ToastContext_1 = require("context/ToastContext");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
// Sticky read-only-maintenance ticker (config.underMaintenance). Reads keep working; writes are paused.
// While it is mounted it also arms the client-side write-block (client/Axios) and shows a friendly toast
// if a write is attempted -- so the whole app degrades to read-only cleanly instead of raw 503s.
const MaintenanceTicker = () => {
    const { addToast } = (0, ToastContext_1.useToastContext)();
    (0, react_1.useEffect)(() => {
        (0, Axios_1.setReadOnlyMode)(true);
        (0, Axios_1.setOnBlockedWrite)(() => addToast({
            type: 'warning',
            title: locale_key_enum_1.LocaleKey.well_be_back_soon.h5locale().capitalize(),
            msg: locale_key_enum_1.LocaleKey.happy5_is_currently_under_maintenance_we_apologize_for_the_inconvenience_and_appreciate_your_patience
                .h5locale()
                .capitalizeSentences()
        }));
        return () => {
            (0, Axios_1.setReadOnlyMode)(false);
            (0, Axios_1.setOnBlockedWrite)(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement("div", { role: "status", className: "sticky top-0 z-[9999] flex w-full items-center justify-center gap-[8px] bg-y-100 px-[16px] py-[10px] text-n-900 shadow-sm" },
        react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-under-construction", width: 16 }),
        react_1.default.createElement("p", { className: "typography-h100 text-center font-medium" }, locale_key_enum_1.LocaleKey.happy5_is_currently_under_maintenance_we_apologize_for_the_inconvenience_and_appreciate_your_patience
            .h5locale()
            .capitalizeSentences())));
};
exports.default = MaintenanceTicker;
